// frontend/src/audio/denoiseLog.ts
// Fire-and-forget lifecycle logger — sends events to POST /api/denoise/log
// via sendBeacon (no auth header, works during unload).
// Extracted to its own module to avoid circular imports between
// denoise.ts and DenoiseEngine.ts.

/** Send a lifecycle event to the backend for server-side logging. */
export function denoiseLog(data: Record<string, unknown>): void {
  try { navigator.sendBeacon('/api/denoise/log', JSON.stringify({ ts: Date.now(), ...data })) } catch {}
}
